import { useEffect } from 'react';

import { useAppDispatch, useAppSelector } from 'app/hooks';
import {
    selectCurrentDrawerId,
    setSaveButtonEnabled,
} from 'common/components/EditDrawer/editDrawerSlice';
import { IUser } from 'common/components/sharedCustomComponents/userProfileSearchDropdown/UserProfileSearchDropdown';
import { ClaimDataTypes } from 'common/constants/claimDataTypes';
import { DrawerIDs } from 'common/utils/DrawerIDs';

export function useValidateLinkFields(params: {
    isDrawerOpened: boolean,
    isLinkOperation: boolean,
    validationFields: {
        userInfo: IUser | null,
        claimValue: string
    },
    claimDataTypeName: string
}) {
    const {
        isDrawerOpened,
        isLinkOperation,
        validationFields,
        claimDataTypeName
    } = params;
    const { userInfo, claimValue } = validationFields;

    const dispatch = useAppDispatch();
    const currentDrawerId = useAppSelector(selectCurrentDrawerId);

    const _isClaimDataTypeIsPermission = (claimDataType: string): boolean =>
        claimDataType === ClaimDataTypes.PERMISSION;

    const _areRequiredLinkFieldsFilled = (
        user: IUser | null,
        claimValueParam: string,
        claimDataTypeNameParam: string
    ): boolean => {
        if(_isClaimDataTypeIsPermission(claimDataTypeNameParam)) {
            return !!user;
        }
        return !!user && Boolean(claimValueParam);
    };

    useEffect(() => {
        // Only run validation when drawer is open and drawer ID matches
        if (!isDrawerOpened || currentDrawerId !== DrawerIDs.User) return;

        if(isLinkOperation &&
            _areRequiredLinkFieldsFilled(userInfo, claimValue, claimDataTypeName)
        ) {
            dispatch(setSaveButtonEnabled(true));
        } else if(isLinkOperation &&
            !_areRequiredLinkFieldsFilled(userInfo, claimValue, claimDataTypeName)
        ) {
            dispatch(setSaveButtonEnabled(false));
        }
    }, [
        isDrawerOpened,
        currentDrawerId,
        userInfo?.id,
        claimValue,
        claimDataTypeName
    ]);
}
